import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { cookieBanner } from 'shared/components/Alert';
import { login } from 'shared/api/authorization';
import { setIsUserLoggedIn } from 'shared/store/features/isUserLoggedInSlice';
import { useDispatch } from 'react-redux';
import { setAlert } from 'shared/store/features/alertSlice';

const Authorization = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = new URLSearchParams(history.location.search);
  const ticket = params.get('ticket');
  useEffect(() => {
    login(ticket)
      .then(() => {
        dispatch(setIsUserLoggedIn({ isUserLoggedIn: true }));
        history.push('/');
      })
      .catch(error => {
        dispatch(
          setAlert({
            open: true,
            variant: 'danger',
            text: `${error.message}${cookieBanner}`
          })
        );
      });
  }, []);
  return <></>;
};

export default Authorization;
